import type { UseMutationResult } from "react-query";
import type { PaywallGroupProps } from "@/react/types/PaywallGroup";
import type { ApiError } from "@circle-react/config/CustomErrors";
import { usePaywallGroupApi } from "./usePaywallGroupApi";

interface Modal {
  hide: () => void;
}

interface UsePaywallGroupParams {
  modal: Modal;
  paywallGroup?: PaywallGroupProps;
  refetchPaywallGroups: () => void;
}

interface PaywallGroupFormDefaults {
  currency_id?: number;
  id?: number;
  name: string;
}

interface UsePaywallGroupReturn {
  closeModal: () => void;
  getFormDefaults: () => PaywallGroupFormDefaults;
  isEditionMode: boolean;
  mutation: UseMutationResult<
    PaywallGroupProps,
    ApiError,
    PaywallGroupFormDefaults
  >;
  refetchPaywallGroups: () => void;
}

export const usePaywallGroup = ({
  modal,
  refetchPaywallGroups,
  paywallGroup,
}: UsePaywallGroupParams): UsePaywallGroupReturn => {
  const getFormDefaults = (): PaywallGroupFormDefaults => ({
    name: paywallGroup?.name || "",
    id: paywallGroup?.id,
    currency_id: paywallGroup?.currency?.id,
  });

  const { createMutation, updateMutation } = usePaywallGroupApi({
    closeModal: modal.hide,
  });

  const isEditionMode = !!paywallGroup;
  const mutation = isEditionMode ? updateMutation : createMutation;

  return {
    getFormDefaults,
    isEditionMode,
    mutation,
    closeModal: modal.hide,
    refetchPaywallGroups,
  };
};
